// Batch 35 · fork U — B35-11: the lock readiness table on File Assembly (always visible) and the W11 line. EN + AR.
export const I18N_B35U = {
  en: {
    b35u: {
      title: "Lock readiness",
      subtitle: "What the file lock checks — the same list as the lock preflight. Click a row to open the item.",
      blocking: "{count} items block the lock",
      blockingOne: "1 item blocks the lock",
      ready: "Ready to lock",
      warnings: "{count} warnings — shown only, they do not block the lock",
      refresh: "Refresh",
      loadFailed: "Could not load the lock check.",
      blocks: "Blocks",
      warning: "Warning",
      open: "Open",
      h: { item: "Item", folder: "FS head / folder", missing: "What is missing", level: "Level", why: "Why", open: "Open" },
      kind: { substantive: "Substantive work", not_started: "Not started", signoff: "Sign-off level", other: "Other" },
      w11Line: "Lock readiness — {count} items",
      w11Detail: "Items that block the file lock (File Assembly)",
    },
  },
  ar: {
    b35u: {
      title: "جاهزية القفل",
      subtitle: "ما يتحقق منه قفل الملف — القائمة نفسها التي تظهر قبل القفل. انقر على صف لفتح البند.",
      blocking: "{count} بنود تمنع القفل",
      blockingOne: "بند واحد يمنع القفل",
      ready: "جاهز للقفل",
      warnings: "{count} تنبيهات — للعرض فقط، لا تمنع القفل",
      refresh: "تحديث",
      loadFailed: "تعذّر تحميل فحص القفل.",
      blocks: "يمنع",
      warning: "تنبيه",
      open: "فتح",
      h: { item: "البند", folder: "بند القوائم / المجلد", missing: "الناقص", level: "المستوى", why: "السبب", open: "فتح" },
      kind: { substantive: "عمل جوهري", not_started: "لم يبدأ", signoff: "مستوى التوقيع", other: "أخرى" },
      w11Line: "جاهزية القفل — {count} بنود",
      w11Detail: "البنود التي تمنع قفل الملف (تجميع الملف)",
    },
  },
};

export default I18N_B35U;
